import { useState, useRef, useEffect } from 'react';
import { backendPort } from '../components/Fungsiku';
import axios from "axios";
import api from "../services/axiosInstance";
import { useNotification } from './NotifPopup';
import { convertAndCompressImage } from '../components/CompressImage';
import { useConfirm } from './ModalConfirm';

const REQ_GROUP_PAGE17_SUBMIT = 'page17-petty-submit';

//FORM INPUT
export function PageKonten17({token, authIdentity = {}, globalOpsi}) {
  const opsiCabang = globalOpsi.opsiCabang;
  const opsiSumber = globalOpsi.opsiSumber;
  const opsiAkun = globalOpsi.opsiAkun;
  const opsiSubAkun = globalOpsi.opsiSubAkun;
  const { showNotif } = useNotification();
  const { showConfirm } = useConfirm();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const isPusat = kodeCabangUser === "C-1";
  const formatTanggal = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };
  const formkosong = {
      cabang : kodeCabangUser,
      jenis : isPusat ? "drp" : "nrm",
      tanggal: '',
      sumber: '',
      akun: '',
      subakun: '',
      nominal: 0,
      catatan: '',
    };
  const [input, setInput] = useState(formkosong);
  useEffect(() => {
    setInput((prev) => ({
      ...prev,
      cabang: prev?.cabang || kodeCabangUser,
    }));
  }, [kodeCabangUser]);
  const fileRef = useRef(null);
  const isValid =()=> input?.sumber && input?.akun && input?.subakun && input?.nominal > 0 && input?.tanggal;
  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
  };
  const [isSubmitting, setIsSubmitting] = useState(false); //cegah submit ganda saat proses belum selesai
  const handleSubmit = async () => {
  if (isSubmitting) return;
  try {
    
    // Validasi sederhana (optional)
    if (!input?.sumber || !input?.akun || !input?.subakun || input?.nominal <= 0 || !input?.tanggal ) {
      showNotif('error', 'Data belum lengkap');
      return;
    }
    
    // Buat FormData untuk kirim data + file
    const formData = new FormData();
    //const dateObj = new Date(input?.tanggal ?? null);
    //const formattedTanggal = `${dateObj.getFullYear()}-${String(dateObj.getMonth()+1).padStart(2,'0')}-${String(dateObj.getDate()).padStart(2,'0')} ${String(dateObj.getHours()).padStart(2,'0')}:${String(dateObj.getMinutes()).padStart(2,'0')}:${String(dateObj.getSeconds()).padStart(2,'0')}`;
    const inputNominal = ()=>{
      if(input.jenis === 'kor' || input.jenis === 'drp') {return Number(input.nominal)}
      else {return Number(input.nominal) * -1}
    }

    formData.append('kode_cabang', input.cabang);
    formData.append('jenis', input.jenis);
    formData.append('tanggal', input.tanggal);
    formData.append('nominal', inputNominal());
    formData.append('sumber', input.sumber);
    //formData.append('sal_sumber', input.koreksi === 'kor' ? Number(saldoSumber(input.sumber))+Number(input.nominal) : Number(saldoSumber(input.sumber))-Number(input.nominal));
    formData.append('akun', input.akun);
    formData.append('subakun', input.subakun);
    //formData.append('saldo', input.koreksi === 'kor' ? Number(saldoCabang())+Number(input.nominal) : Number(saldoCabang())-Number(input.nominal));
    formData.append('user', namaUser || input?.user || '');
    formData.append('catatan', input.catatan || '');

    if (input.bukti) {
      formData.append('bukti', input.bukti); // file bisa berupa image/pdf
    }
    
    // Kirim request ke server
    setIsSubmitting(true);
    api.cancelPendingRequests({
      group: REQ_GROUP_PAGE17_SUBMIT,
      reason: 'submit petty jurnal form terbaru',
    });
    const res = await api.post(
      `${backendPort}/api/main/petty_jurnal_form`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        requestGroup: REQ_GROUP_PAGE17_SUBMIT,
        timeout: 120000,
      }
    );
    showNotif('success', 'Data berhasil ditambahkan');
    console.log('Response server:', res.data);
    // Kosongkan input setelah request sukses
    setInput(formkosong);
    setFile(null);
    setPreview(null);
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  } catch (err) {
    if (api.isCanceledError(err)) return;
    console.error('Error submit:', err);
    showNotif('error', 'Penambahan Data Error');
  } finally {
    setIsSubmitting(false);
  }
  };

  const handleFile = async (e) => {
    const f = e.target.files[0];
    if (!f) return;

    const file = await convertAndCompressImage(f)
      .catch(err => {
        console.error('Error convert and kompress file:', err);
        if (f.size > 5 * 1024 * 1024) {
          showNotif('error', 'File melebihi 5MB');
          return null;
        }; // fallback ke file asli jika proses gagal
      });
    
    if(!file) return;  
    setFile(file);
    setInput(prev=>({...prev, bukti: file}));
      
    if (file.type.startsWith('image/')) {
      setPreview(URL.createObjectURL(file));
    } else {
      setPreview(null);
    }
  };

  useEffect(() => { //Mencegah memori leak dari URL.createObjectURL
  return () => {
    if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  return (
    <div><form className="space-y-4">

      {/* Jenis Transaksi */}
      {isPusat && <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Untuk unit</label>
        <select className="col-span-9 border rounded px-3 py-2"
                value={input.cabang}
                onChange={(e) => {setInput(prev=>({...prev, cabang: e.target.value}))}}>
                {opsiCabang.map((x,i)=> <option key={`${i}-${x.kode_cabang}`} value={x.kode_cabang}>{x.nama_cabang}</option>)}  
        </select>
      </div>}

      {/* Jenis Transaksi */}
      <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Jenis Transaksi</label>
        <select className="col-span-9 border rounded px-3 py-2"
                value={input.jenis}
                onChange={(e) => {setInput(prev=>({...prev, jenis: e.target.value}))}}
          >
          {isPusat ? <option value="drp">Dropping Dana</option> : null}
          {isPusat ? <option value="kdr">Koreksi Dropping Dana</option> : null}  
          <option value="nrm">Transaksi Belanja</option>
          <option value="kor">Koreksi Belanja</option>
        </select>
      </div>
      
      {/* No Transaksi */}
      <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Sumber Dana</label>
        <select className="col-span-9 border rounded px-3 py-2"
                value={input.sumber}
                onChange={(e) => {setInput(prev=>({...prev, sumber: e.target.value}))}}
          >
          <option value="">Pilih Sumber Dana</option>
          {opsiSumber.map((x,i) => <option key = {`${i}-${x.sumber}`} value = {x.sumber}>{x.sumber}</option>)}
        </select>
      </div>

      {/* Akun */}
      <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Akun</label>
        <select className="col-span-9 border rounded px-3 py-2"
                value={input.akun}
                onChange={(e) => {setInput(prev=>({...prev, akun: e.target.value}))}}
          >
          <option value="">Pilih Akun</option>
          {(input.jenis === 'drp' || input.jenis === 'kdr') && <option value="PUSAT">Dropping dana</option>}
          {(input.jenis === 'nrm' || input.jenis === 'kor') && opsiAkun.map((x,i) => <option key = {`${i}-${x.akun}`} value = {x.akun}>{x.akun}</option>)}
        </select>
      </div>

      {/* Sub Akun */}
      <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Sub Akun</label>
        <select className="col-span-9 border rounded px-3 py-2"
                value={input.subakun}
                onChange={(e) => {setInput(prev=>({...prev, subakun: e.target.value}))}}
          >
          <option value="">Pilih SubAkun</option>
          {(input.jenis === 'drp' || input.jenis === 'kdr') && input.akun !== ""  && isPusat && <option value="DROPPING">Dropping dana</option>}
          {input.akun !== ""  && opsiSubAkun.map((x,i) => x.akun === input.akun ? <option key = {`${i}-${x.subakun}`} value = {x.subakun}>{x.subakun}</option> : null)}
        </select>
      </div>

      {/* Keterangan */}
      <div className="grid grid-cols-12 items-start gap-4">
        <label className="col-span-3 font-medium pt-2">Keterangan</label>
        <textarea
          rows="3"
          className="col-span-9 border rounded px-3 py-2"
          placeholder="Keterangan transaksi"
          value={input.catatan}
          onChange={e => setInput(prev=>({...prev, catatan: e.target.value}))}
        />
      </div>

      {/* Nominal */}
      <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Nominal</label>
        <input
          type="text"
          inputMode="numeric"
          className="col-span-9 border rounded px-3 py-2"
          placeholder="0"
          value={formatRibu(input.nominal)}
          onChange={(e) => {
            const raw = e.target.value.replace(/[^\d]/g, '');
            setInput(prev => ({
              ...prev,
              nominal: raw === '' ? 0 : Number(raw)
          }));
    }}
        />
      </div>

      {/* Tanggal */}
      <div className="grid grid-cols-12 items-center gap-4">
        <label className="col-span-3 font-medium">Tanggal Transaksi</label>
        <input
          type="date"     
          max={new Date()}
          className="col-span-9 border rounded px-3 py-2"
          value={input.tanggal}
          onChange={e => setInput(prev=>({...prev, tanggal: e.target.value}))}
        />
      </div>

      {/* Upload Bukti */}
      <div className="grid grid-cols-12 items-start gap-4">
        <label className="col-span-3 font-medium pt-2">
          Bukti Transaksi
        </label>

        <div className="col-span-9 space-y-2">
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,image/*"
            onChange={handleFile}
            ref={fileRef}
            className="block"
          />

          {/* Preview */}
          {preview && (
            <img
              src={preview}
              alt="preview"
              className="w-24 h-24 object-cover border rounded"
            />
          )}

          {file && file.type === 'application/pdf' && (
            <div className="text-sm text-gray-600">
              File PDF: {file.name}
            </div>
          )}
        </div>
      </div>

      {/* Action */}
      <div className="flex justify-end gap-2 pt-4">
        <button
          onClick={()=>{
            setInput(formkosong);
            setFile(null);
            setPreview(null);}
          }
          type="button"
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Batal
        </button>
        <button
          onClick={async () =>showConfirm({
              title: 'Submit Transaksi',
              message: 'Lanjutkan?',
              onConfirm: () => {handleSubmit()}
              })}
          type="button"
          className={`px-4 py-2 rounded text-white ${isValid() ? 'bg-blue-600' : 'bg-gray-400 cursor-not-allowed'}`}
          disabled={!isValid()}
        >
          Simpan
        </button>
      </div>

    </form>
    </div>
  );
}
